import { topspanderModul_get_all_cabang_reducers } from "../reducers/TopSpanderAllCabangReducers";
import { topspanderModul_get_cabang_reducers } from "../reducers/TopSpanderCabangReducers";

const modulTopSpander = {
  topspanderModul_get_all_cabang: topspanderModul_get_all_cabang_reducers,
  topspanderModul_get_cabang: topspanderModul_get_cabang_reducers,
};

export default modulTopSpander;
